<template>
  <div class="talent-list">
    <h3 v-if="$route.name === 'scholarSearchHistoryGuoJiao' || $route.name === 'scholarSearchHistory'"
        :style="{top: $route.name === 'scholarSearchHistoryGuoJiao' ? '0' : '80px'}"
    >
      <b>来源专家</b>
      <el-input
        size="small"
        v-model="searchScholarInput"
        class="search-scholar-input"
        placeholder="请输入专家姓名或机构"
        clearable
      ></el-input>
    </h3>
    <div
      class="talent-item"
      v-for="(talentItem, index) in filteredList"
      :key="index"
    >
      <el-avatar
        class="avatar"
        :size="45"
        :src="talentItem.avatar"
        @click="toScholarDetails(talentItem.scholar_id)"
      ></el-avatar>
      <div class="talent-info">
        <div class="name-title">
          <span @click="toScholarDetails(talentItem.scholar_id)">{{
            talentItem.scholar_name
          }}</span>
          <i
            v-for="(tit, idx) in talentItem.showLeftList"
            :title="tit"
            :key="idx"
            >{{ tit }}</i
          >
        </div>
        <div class="info">
          <label style="line-height: 18px">所在机构：</label>
          <span
            style="cursor:pointer;"
            @click="toOrgDetail(talentItem)"
          >{{ talentItem.org_name || '-' }}</span>
        </div>
        <div class="info">
          <label style="line-height: 18px">研究领域：</label>
          <p v-if="talentItem.fields && talentItem.fields.length">
            <span v-for="(field, i) in talentItem.fields" :key="i"
              >{{ field.name }}；</span
            >
          </p>
          <p v-else>-</p>
        </div>

        <div class="data-number">
          <div class="flex">
            <p>
              成果数：<span>{{ talentItem.publications_count || '-' }}</span>
            </p>
            <p>
              H指数：<span>{{ talentItem.hindex || '-' }}</span>
            </p>
            <p>
              引用数：<span>{{ talentItem.citedby || '-' }}</span>
            </p>
          </div>

          <!--          <p v-if="talentItem.person_url">-->
          <!--            个人主页：<a :href="talentItem.person_url" target="_blank">{{-->
          <!--              talentItem.person_url-->
          <!--            }}</a>-->
          <!--          </p>-->
        </div>
        <!--  个人主页  -->
        <div class="infoLine">
          <span class="flex items-center">个人主页：</span>
          <div
            style="
              width: 21px;
              height: 21px;
              border-radius: 50%;
              background-color: #3860F4;
            "
            :style="{
              backgroundColor: talentItem.person_url ? '#3860F4' : '#999999',
            }"
            class="pointer flex justify-center items-center"
            @click="goInfoUrl(talentItem.person_url)"
          >
            <img
              width="14px"
              height="14px"
              :src="require('@/assets/images/talent/boshi.png')"
              alt=""
            />
          </div>
          <div
            style="
              width: 21px;
              height: 21px;
              border-radius: 50%;
              margin-left: 10px;
            "
            :style="{
              backgroundColor: talentItem.googleAddress ? '#3860F4' : '#999999',
            }"
            class="flex justify-center items-center pointer"
            @click="goInfoUrl(talentItem.googleAddress)"
          >
            <img
              width="14px"
              height="14px"
              :src="require('@/assets/images/talent/google.png')"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>

    <el-empty v-if="!filteredList.length" />
  </div>
</template>

<script>
export default {
  name: 'talentItemComp',
  components: {},
  props: [
    'talentListData', // 父级传递的人才列表数据
  ],
  data() {
    return {
      searchScholarInput: '', // 检索来源专家输入的值
    };
  },
  created() {
    console.log(this.$route.name);
  },
  computed: {
    filteredList() {
      const keyword = this.searchScholarInput.trim().toLowerCase();
      if (!keyword) return this.talentListData; // 这里的 scholarCardData 是你的原始数组

      return this.talentListData.filter((item) => {
        return (
          item.scholar_name.toLowerCase().includes(keyword) ||
          item.org_name.toLowerCase().includes(keyword)
        );
      });
    },
  },
  methods: {
    /**
     * 跳转人才详情
     * @param id 人才id
     */
    toScholarDetails(id) {
      if (this.$route.name === 'scholarSearchHistory') {
        let obj = {
          name: 'talentDetail',
          query: { id },
        };
        let routeData = this.$router.resolve(obj);
        window.open(routeData.href, '_blank');
      } else {
        let obj = {
          name: 'talentDetailGuoJiao',
          query: { id },
        };
        this.$router.push(obj);
      }

    },

    // 跳转个人主页
    goInfoUrl(url) {
      if (url) {
        window.open(url);
      }
    },

    // 跳转机构详情
    toOrgDetail(item) {
      console.log(item);
      let id = item.org_id;
      let type = item.org_type;
      let area = item.source === 'zhitu' ? '国内' : '国外';

      if (id && type && area) {
        let obj = {
          name: 'orgDetail',
          query: { orgId: id, orgType: type, orgArea: area},
        };
        let routeData = this.$router.resolve(obj);
        window.open(routeData.href, '_blank');
      }
    },
  },
  watch: {},
};
</script>

<style scoped lang="less">
.talent-list {
  padding-top: 55px;
  > h3 {
    color: #333333;
    padding: 15px 10px;
    position: fixed;
     background-color: #ffffff;
    z-index: 99;
    width: 100%;

    b {
      font-size: 16px;
    }
  }
}
.talent-item {
  display: flex;
  padding: 15px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);

  .avatar {
    cursor: pointer;
    flex-shrink: 0;
  }

  .talent-info {
    //width: calc(100% - 430px);
    padding: 0 12px;

    .name-title {
      display: flex;
      width: 80%;
      cursor: pointer;
      max-width: 400px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      span {
        //max-width: 30%;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 18px;
        color: #333333;
      }

      i {
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-style: normal;
        font-size: 11px;
        background-color: #f4f9ff;
        border-radius: 4px;
        color: #3860F4;
        padding: 0 5px;
        margin-left: 3px;
        height: 20px;
        line-height: 20px;
      }
    }

    .info {
      font-size: 13px;
      margin-top: 6px;
      display: flex;

      label {
        color: #999;
        width: 64px;
        white-space: nowrap;
        flex-shrink: 0;
      }

      span {
        color: #333333;
        flex-wrap: wrap;
        line-height: 18px;
        //overflow: hidden;
        //text-overflow: ellipsis;
        //white-space: nowrap;
        //word-wrap: normal;
        //box-sizing: border-box;
      }
    }

    .data-number {
      display: flex;
      flex-wrap: wrap;

      p {
        margin-top: 6px;
        font-size: 13px;
        color: #999999;
        display: flex;
        align-items: center;
        margin-right: 25px;
        flex-shrink: 0;

        span {
          color: #3860F4;
          font-weight: bold;
          word-wrap: normal;
          flex-shrink: 0;
        }

        a {
          color: #333333;
          text-decoration: underline;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          max-width: 700px;
        }
      }
    }

    .infoLine {
      display: flex;
      margin-top: 10px;
      font-size: 13px;
      color: #999999;
      align-items: center;
    }
  }
}

.search-scholar-input {
  width: 200px;
  margin-left: 20px;
}
</style>
